import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import PrimaryButton from '~/components/views/common/buttons/PrimaryButton/PrimaryButton';
import { Icon } from 'hfs-common-ui';
import './OldVersionWarning.pcss';

export interface Props {
  setShowOldVersionWarning(showOldVersion: boolean): void;
}

const OldVersionWarning = ({ setShowOldVersionWarning }: Props) => {
  const appTimestamp = useSelector((state: AppState) => state.app.timestamp);

  const handleCloseWarning = useCallback(() => {
    setShowOldVersionWarning(false);
  }, [setShowOldVersionWarning]);

  useEffect(() => {
    if (appTimestamp) {
      localStorage.setItem('oldVersionWarningTimestamp', appTimestamp);
    }
  }, [appTimestamp]);

  return (
    <div className="OldVersionWarning">
      <div className="message-header">
        <FormattedMessageWrapper langKey="web.old_version_warning.message.header" />
      </div>
      <div className="message-content">
        <FormattedMessageWrapper langKey="web.old_version_warning.message.content" />
      </div>
      <div className="refresh-wrapper">
        <PrimaryButton
          langKey="web.old_version_warning.button.reload_page"
          onClick={() => window.location.reload()}
        />
      </div>

      <div className="close-version-warning" onClick={handleCloseWarning}>
        <Icon type="action.close" size="medium" />
      </div>
    </div>
  );
};

export default OldVersionWarning;
